"use strict";
var oAuthUtils = (function () {
    function oAuthUtils() {
    }
    oAuthUtils.generateRandomString = function () {
        var array = new Uint32Array(56 / 2);
        window.crypto.getRandomValues(array);
        var s = '';
        for (var i = 0; i < array.length; i++) {
            s += ('0' + array[i].toString(16)).substr(-2);
        }
        return s;
    };
    oAuthUtils.sha256 = function (plain, callback) {
        var data = oAuthUtils.str2ab(plain);
        window.crypto.subtle.digest('SHA-256', data).then(function (hashed) {
            callback(hashed);
        });
    };
    oAuthUtils.str2ab = function (str) {
        var buf = new ArrayBuffer(str.length);
        var bufView = new Uint8Array(buf);
        for (var i = 0, strLen = str.length; i < strLen; i++) {
            bufView[i] = str.charCodeAt(i);
        }
        return bufView;
    };
    oAuthUtils.base64urlencode = function (a) {
        var str = "";
        var bytes = new Uint8Array(a);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            str += String.fromCharCode(bytes[i]);
        }
        return btoa(str)
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=+$/, "");
    };
    oAuthUtils.challenge_from_verifier = function (v, callback) {
        oAuthUtils.sha256(v, function (hashed) {
            var base64encoded = oAuthUtils.base64urlencode(hashed);
            callback(base64encoded);
        });
    };
    return oAuthUtils;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = oAuthUtils;
//# sourceMappingURL=oAuthUtils.js.map